import React, { useState } from "react"
import "./header.scss"
import { homeNavigation, navigation } from "./navigation"
import { UniversalNavLink } from "./UniversalNavLink"

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  return (
    <>
      <header className="header">
        {/* Mobile logo - always visible on mobile */}
        <div className="mobile-logo md:hidden">
          <UniversalNavLink nav={homeNavigation} className="logo" />
          <p className="logo-description">
            The XRPL Grants program seeks to enable others to build inclusive
            standards leveraging the XRP Ledger’s open source technology and
            further innovate in the Internet of Value.
          </p>
        </div>

        <input
          className="side-menu"
          type="checkbox"
          id="side-menu"
          checked={isMobileMenuOpen}
          onChange={handleMobileMenuToggle}
        />
        <label className="mobile-menu-toggle" htmlFor="side-menu">
          <span className="mobile-menu-line" />
        </label>

        <nav
          className={`${isMobileMenuOpen ? `block` : `hidden`} md:block nav`}
        >
          <ul className="menu">
            {/* XRPL Grants as first item on desktop only */}
            <li className="logo-item">
              <UniversalNavLink nav={homeNavigation} className="logo" />
            </li>
            {/* Show all navigation items */}
            {navigation.map((nav) => (
              <li key={nav.name}>
                <UniversalNavLink nav={nav} />
              </li>
            ))}
          </ul>
        </nav>
      </header>
    </>
  )
}
